export function encodeBase64Json(obj) {
  try {
    const json = JSON.stringify(obj || {});
    return btoa(unescape(encodeURIComponent(json)));
  } catch {
    return '';
  }
}